// extracted by mini-css-extract-plugin
module.exports = {"info-tooltip":"info-tooltip-3ClKig3"};